import { useProviderStore } from "core/store/providerStore";

export default function OrgSwitcher({
  className = "",
}: {
  className?: string;
}) {
  const { orgMemberships, activeOrgId, setActiveOrgId } = useProviderStore();

  if (orgMemberships.length <= 1) return null;

  return (
    <div className={className}>
      <label className="block text-xs font-bold text-slate-500 uppercase mb-1">
        Organisation
      </label>
      <select
        value={activeOrgId ?? ""}
        onChange={(e) => setActiveOrgId(e.target.value || null)}
        className="w-full max-w-xs rounded-xl border border-slate-200 px-3 py-2 text-sm bg-white"
      >
        {orgMemberships.map((m) => (
          <option key={m.orgId} value={m.orgId}>
            {m.orgName}
          </option>
        ))}
      </select>
    </div>
  );
}
